import { render, staticRenderFns } from "./ExamEnd.vue?vue&type=template&id=eb6e24c6&"
import script from "./ExamEnd.vue?vue&type=script&lang=js&"
export * from "./ExamEnd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports